import type { RouteObject } from 'react-router';
import { ownerNav } from '@/lib/nav/owner';
import { collectRoutes } from '../routes';

const modules = import.meta.glob<{ routes: RouteObject[] }>('./*/routes.tsx', { eager: true });

export const ownerRoutes = collectRoutes(modules, ownerNav, '/app');
